<template>
  <div
    id="page-wrapper"
    role="main"
    class="grocery-bag-page"
  >
    <div class="wrap-container">
      <on-page-breadcrumbs :data="breadcrumbs" />
    </div>
    <div
      v-edit="'heroImage'"
      class="grocery-bag-page__hero-image"
      :style="{paddingTop: image ? '0' : '8rem'}"
    >
      <epi-picture
        v-if="image"
        :use-picture="false"
        :fit-dimensions="false"
        :auto-aspect-ratio="false"
        :image="image"
        :sizes="dimensions"
        edit="Image"
      />
    </div>
    <div class=" wrap-container">
      <div class="grocery-bag-page__bag">
        <div
          ref="storeModal"
        >
          <div
            v-if="showStoreSearchModal"
            class="modal-wrapper"
          />
          <select-store-modal
            v-if="showStoreSearchModal"
            v-model="showStoreSearchModal"
            :results="[]"
          />
        </div>
        <div class="row-center-noGutter fade-in">
          <preamble-block
            class="col-12_md-8_lg-6"
            :prefix="prefix"
            :title="title"
            :preamble="preamble"
          />
        </div>

        <div
          v-if="currentBag"
          class="grocery-bag-page__recipes-container"
        >
          <div class="row-noGutter">
            <div class="col-6 select-week-container">
              <ica-select-element
                v-model="selectedWeek"
                aria-label="Välj vecka"
                :options="weeks"
              />
            </div>
            <div class="col-6">
              <div v-if="pdf">
                <p class="grocery-bag-page__recipes-pdf">
                  <a
                    :href="pdf"
                    target="_blank"
                  >
                    Receptblad
                    <svgicon
                      class=""
                      name="Misc/Pdf"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <grocery-bag-recipe-block
                v-for="recipe in recipes"
                :key="recipe.id"
                :recipe="recipe"
              />
            </div>
          </div>
        </div>
        <div class="grocery-bag-page__description-container">
          <div
            v-if="atHomeItems && atHomeItems.length"
            class="row grocery-bag-page__athome"
          >
            <div class="col-12">
              <p><strong>Ingredienser som du behöver ha hemma den här veckan</strong></p>
              <span
                v-for="item in atHomeItems"
                :key="item.id"
                class="grocery-bag-page__athome-item button--secondary button--32"
              >{{ item.value }}</span>
            </div>
            <!-- <div
              name"TO BE IMPLEMENTED LATER"
              v-if="store"
              class="col-12"
            >
              Till butik
            </div> -->
          </div>
          <div class="row-center-noGutter">
            <div class="col-12">
              <div
                v-if="content || isEditable"
                class="grocery-bag-page__content"
              >
                <wysiwyg
                  v-if="content || isEditable"
                  v-edit="'Content'"
                  class="wysiwyg--contentarea"
                  :content="content"
                />
              </div>
              <div
                v-if="contentBlocks.length || (isEditable && contentBlocks.length)"
                v-edit="'ContentBlocks'"
              >
                <component
                  :is="block.component | kebab"
                  v-for="block in contentBlocks"
                  :key="block.contentId"
                  v-bind="block"
                />
              </div>
              <div class="grocery-bag-page__bag-hero">
                <bag-hero
                  v-if="currentBag"
                  :current-product="selectedProduct"
                  :bag="currentBag"
                  @productChanged="selectedProductChanged"
                  @showModal="toggleSearchModal"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="featureContent && featureContent.length || isEditable"
          class="row-noGutter border-top feature-container"
        >
          <div class="col-12">
            <div class="bag-features">
              <div
                v-if="currentBag"
                class="tag"
              >
                {{ currentBag.name }}
              </div>
              <wysiwyg
                v-if="featureContent || isEditable"
                v-edit="'FeatureContent'"
                :content="featureContent"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="accordionBlocks.length || (isEditable && accordionBlocks.length)"
        class="accordion-block-wrapper"
      >
        <sub-heading
          v-if="accordionsHeading || isEditable"
          :v-edit-heading="'AccordionsHeading'"
          :heading="accordionsHeading"
        />

        <in-view
          :threshold="0"
          :threshold-type="'px'"
          class="slide-into-view-transition"
        >
          <div
            v-edit="'AccordionBlocks'"
          >
            <accordion-group
              :items="accordionBlocks | stringify('content')"
              :limit="isEditable ? 0 : accordionShowMoreLimit"
              :tracking-scope="accordionsHeading"
            />
          </div>
        </in-view>
      </div>
      <sub-heading
        v-if="renderContent.length"
        heading="Fler matkassar"
      />
      <block-grid
        v-if="renderContent.length || (isEditable && renderContent.length)"
        v-edit="'ContentArea'"
        :blocks="renderContent"
        :force-row-size="'third'"
      />

      <navigation-blocks
        v-if="allNavigatablePages.length"
        :navigation-blocks="allNavigatablePages"
        :display-image-state="displayImagesInNavigationBlocks"
      >
        <sub-heading
          v-if="navigationHeading || isEditable"
          :v-edit-heading="'NavigationHeading'"
          :heading="navigationHeading"
        />
      </navigation-blocks>

      <additional-navigation-blocks
        v-if="isEditable"
        :items="additionalNavigatablePages"
      />
    </div>
  </div>
</template>

<script>
import BagFilter from './BagFilter'
import BagHero from './BagHero'
import FluidBlock from "@/vue/components/FluidBlock"
import IcaSelect from '~/@ica/ica-molecules-vue/dist/SelectElement'
import PreambleBlock from '@/vue/blocks/PreambleBlock/preambleBlock'
import SelectStoreModal from '@/vue/components/storePicker/subcomponents/selectStoreModal'
import axios from 'axios'
import format from 'dateformat'
import { mapState } from 'vuex'
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import pageBlockTypes from '@/vue/mixins/pageBlockTypes'
import GroceryBagRecipeBlock from '@/vue/blocks/GroceryBagRecipeBlock/groceryBagRecipeBlock'
import '#/Misc/Pdf'

export default {
  name: 'GroceryBagLandingPage',
  components: {
    'ica-select-element': IcaSelect,
    'select-store-modal': SelectStoreModal,
    BagFilter,
    BagHero,
    FluidBlock,
    PreambleBlock,
    GroceryBagRecipeBlock
  },
  mixins: [pageWithNavigation, pageBlockTypes],
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    preamble: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
      default: () => [""]
    },
    featureContent: {
      type: Array,
      default: () => []
    },
    contentBlocks: {
      type: Array,
      default: () => []
    },
    contentAreaTwo: {
      type: Array,
      default: () => []
    },
      accordionBlocks: {
      type: Array,
      default () {
        return []
      }
    },
    accordionsHeading: {
      type: String,
      default: ""
    },
    accordionShowMoreLimit: {
      type: Number,
      default: 0
    },
    image: {
      type: Object,
      default: null,
    }
  },
  data () {
    return {
      atHomeItems: [],
      currentBag: null,
      days: null,
      dimensions: {
        small: {
          width: 375,
          height: 280
        },
        medium: {
          width: 768,
          height: 528
        },
        large: {
          width: 1400,
          height: 528
        }
      },
      pdf: null,
      persons: null,
      recipes: [],
      selectedProduct: null,
      selectedWeek: format(new Date(), 'yyyy-W'),
      // selectedWeek: format(new Date('2019-05-10'), 'yyyy-W'),
      showStoreSearchModal: false,
      renderContent: [],
      year: null,
      week: null,
    }
  },
  computed: {
    ...mapState(['selectedDeliveryMethod','store','storePickerKey']),
    aspectRatio () {
      return this.$root.isSmallViewport ? 100 : 0
    },
    friendlyWeek () {
      if (!this.selectedWeek) {return}
      const weekYear = this.selectedWeek.split('-')
      return `v${weekYear[1]}`
    },
    weeks () {
      function addDays (dt, days) {
        const nd = new Date(dt)
        nd.setDate(dt.getDate() + days)
        return nd
      }

      const res = {}

      for (let i = -1; i <= 2; i++) {
        const wd = addDays(new Date(), 7 * i)
        res[format(wd, 'yyyy-W')] = `Vecka ${format(wd, 'W')}`
      }

      return res
    },
    isSingle () {
      return this.currentBag.products.length == 1
    }
  },
  watch: {
    selectedWeek: function () {
      this.loadRecipes()
    },
    store () {
      this.getGroceryBags()
    },
    storePickerKey () {
      this.toggleSearchModal()
    },
  },
  beforeDestroy () {
    document.removeEventListener('topNavStoreChange',  this.handleStoreCookieChanged)
  },
  mounted () {
    document.addEventListener('topNavStoreChange',  this.handleStoreCookieChanged)

    this.getGroceryBags()
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search)
      if (params.has('y')) {
        this.year = parseInt(params.get('y'), 10)
      }
      if (params.has('w')) {
        this.week = parseInt(params.get('w'), 10)
      }
    }
  },
  methods: {
    handleStoreCookieChanged (event) {
      this.$store.dispatch('handleStoreChangedEvent', event)
    },
    getGroceryBags () {
      const query = {}

      if (this.store) {
        query.storeId = this.store.id
        query.deliveryMethod = this.selectedDeliveryMethod
      }

      const encodedQuery = Object.keys(query).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
      }).join('&')

      const searchUrl = `${this.$root.envConfig.baseUrl}/api/grocerybag/products?${encodedQuery}`

      axios.get(searchUrl)
        .then(data => this.loadContent(data.data))
        .catch(err => console.error(err))
    },
    loadContent (bags) {
      let slug = location.pathname

      if (slug.endsWith('/')) {
        slug = slug.substr(0, slug.length - 1)
      }

      slug = slug.substr(slug.lastIndexOf('/') + 1)

      const titleBags = bags.groups.filter(
        b => this.toSlug(b.name) === slug)

      if (titleBags && titleBags.length > 0) {
        this.currentBag = titleBags[0]
        this.setProduct(titleBags[0])
      }

      this.setContentAreas(bags.groups.filter(b => this.toSlug(b.name) !== slug))
    },
    setProduct (bag) {
      const fourPeopleBags = bag.products.filter((b) => b.peoples === 4)
      const filteredBags = fourPeopleBags.length > 0 ? fourPeopleBags : bag.products
      const cheapest = filteredBags.reduce(
        (prev, curr) => {
          return prev.recommendedPriceHomeDelivery < curr.recommendedPriceHomeDelivery ? prev : curr
        })
      const params = this.parseQueryParams()

      const product = bag.products.filter(
        p => p.peoples === params.selectedPersons
          && p.days === params.selectedDays
          && p.glutenFree === !!params.glutenFree
          && p.lactoseFree === !!params.lactoseFree
          && p.vegetarian === !!params.vegetarian)[0]

      this.selectedProductChanged(product || cheapest)
    },
    parseQueryParams () {
      const data = {}
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search)
        if (params.has('d')) {data.selectedDays = parseInt(params.get('d'), 10)}
        if (params.has('p')) {data.selectedPersons = parseInt(params.get('p'), 10)}
        if (params.has('l')) {data.lactoseFree = params.get('l') === 'true'}
        if (params.has('g')) {data.glutenFree = params.get('g') === 'true'}
        if (params.has('v')) {data.vegetarian = params.get('v') === 'true'}
      }
      return data
    },
    loadRecipes () {
      if (!this.selectedProduct || !this.selectedWeek) {
        return
      }

      if (this.year !== null && this.week !== null){
        axios.get(`${this.$root.envConfig.baseUrl}/api/grocerybag/recipes/${this.selectedProduct.id}/${this.year}/${this.week}`)
          .then(data => this.setRecipes(data.data))
          .catch(err => console.error(err))
      }
      else {
        const weekYear = this.selectedWeek.split('-')
        axios.get(`${this.$root.envConfig.baseUrl}/api/grocerybag/recipes/${this.selectedProduct.id}/${weekYear[0]}/${weekYear[1]}`)
          .then(data => this.setRecipes(data.data))
          .catch(err => console.error(err))
      }
    },
    selectedProductChanged (val) {
      this.selectedProduct = val
      this.loadRecipes()
    },
    setContentAreas (groups) {
      for(let bag of groups) {
        bag.component = "GroceryBagBlock"
        bag.inViewKey = bag.name + this.renderContent.length
        bag.link = './' + this.toSlug(bag.name)
        this.renderContent.push(bag)
      }
      this.renderContent = [...this.renderContent, ...this.contentAreaTwo]
    },
    setRecipes (data) {
      this.atHomeItems = data.atHome.map((val, idx) => {
        return {
          id: idx + val,
          value: val
        }
      })
      this.pdf = data.pdf
      this.recipes = data.recipes
    },
    toggleSearchModal () {
      this.showStoreSearchModal = true
      this.$refs.storeModal.scrollIntoView({
        behavior: 'smooth',
        block: "center"
      })
    },
    toSlug (input) {
      return input.toLowerCase().replaceAll(' ', '-')
    }
  }
}
</script>

<style lang="scss">
@import '~@ica/ica-atoms/components/select';

.border-top {
  border-top: 1px solid #f0f0f0;
}

.grocery-bag-page {
  max-width: 90rem;
  margin: 0 auto 3rem auto;

  .wrap-container {
    @include media-breakpoint-down(sm) {
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
  }

  .grocery-bag-page__hero-image {
    position: relative;
    width: 100%;
    margin: 0;

    .epi-picture {
      max-height: 33rem;
    }

    .epi-background-container {
      padding-bottom: 17.5rem;
      border-radius: 0.25rem;

      @include media-breakpoint-up(md) {
        padding-bottom: 33rem;
        margin: 0 1rem;
      }
    }
  }

  .grocery-bag-page__bag {
    padding: 2rem 0  3.5rem 0;
    border-radius: 0.25rem;
    background-color: $color-white;
    position: relative;
    margin-top: -8rem;
    margin-bottom: 3rem;

    .grocery-bag-page__recipes-container {
      padding: 0 1rem;

      @include media-breakpoint-up(md) {
        max-width: 50rem;
        margin: 0 auto;
      }

      .grocery-bag-page__recipes-pdf {
        float: right;
        font-weight: bold;

        .svg-icon {
          width: 2rem;
          height: 2rem;
          fill: currentColor;
        }
      }
    }

    .grocery-bag-page__description-container {
      max-width: 50rem;
      margin: 0 auto;
    }

    .grocery-bag-page__athome {
      text-align: center;
      padding: 1.5rem 1rem;

      @include media-breakpoint-up(md) {
        padding: 1.5rem 6rem;
      }

      .grocery-bag-page__athome-item {
        margin: 0.5rem;
        cursor: default;

        //lock hover since the buttons does not have a function
        &[class*=button--]:hover {
          background-color: #fcece7;
          color: #cf2e05;
          fill: #cf2e05;
        }
      }
    }

    .feature-container {
      margin-top: 1em;

      .bag-features {
        background-color: #f5faf4;
        color: #2f6147;
        margin: 1em 2em;

        .tag {
          background-color: #e4efc6;
          display: inline-block;
          font-size: 1em;
          font-weight: 500;
          margin-top: 1em;
          padding: 0.3em;
          text-transform: uppercase;
        }

        h4 {
          margin-left: 2em;
        }

        ul {
          margin: 0 2em 1em 2em;
          padding-bottom: 1em;
        }
      }
    }

    [class*="row-"][class*="-noGutter"] .preamble__wrapper {
      padding: 0 2rem;

      @include media-breakpoint-up(md) {
        padding: 0;
      }
    }

    &__media-wrapper {
      margin-bottom: 3rem;
      padding: 0 0.5rem;

      @include media-breakpoint-up(md) {
        padding: 0 3rem;
      }

      @include media-breakpoint-up(lg) {
        padding: 0 3.5rem;
      }

      @include media-breakpoint-up(xl) {
        padding: 0 5rem;
      }

      .epi-background-container,
      .empty-image-placeholder {
        border-radius: 0.25rem;
        padding-bottom: 56.25%;
      }
    }
  }

  .select-week-container {
    margin-bottom: 0.5rem;

    .custom-select {
      z-index: 1;

      @include media-breakpoint-up(sm) {
        max-width: 9.25rem;
      }
    }

    .custom-select .dropdown__label {
      padding: 0.5rem 1rem;
    }
  }

  .grocery-bag-content {
    .filter-header {
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;

      &_title {
        @include font(rubrik, 2, "bold");

        color: $color-brown-dark;
        margin: 0;
      }
    }

    .athome-container {
      &__top-wrapper {
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
      }

      &__bottom-wrapper {
        margin: 1rem 0;
      }

      &__title {
        margin: 0 0 0.5rem;
      }

      &__text {
        margin-top: 0.5rem;
      }

      &__list {
        padding-left: 1rem;
        list-style-type: disc;

        &-item {
          margin-bottom: 0.5rem;
        }
      }

      &__recipe-pdf {
        margin-bottom: 0.5rem;
      }
    }
  }

  .checkbox {
    margin-left: -0.375rem;
    margin-bottom: 0.5rem;

    @include media-breakpoint-up(lg) {
      margin-bottom: 0;
    }

    &__label::before {
      background: $color-white;
    }

    &__label {
      margin-left: 0.25rem;

      @include font(text, 3, "normal");
    }

    input[type="checkbox"]:disabled + label {
      color: $color-grey-mid;
      cursor: not-allowed;
    }
  }
}
</style>
